import Bubble from "./Bubble";
import EventEmitter from "./EventEmitter";
import Utils from "./Utils";

export default class Bubbles extends EventEmitter {
  constructor(container, translations) {
    super();
    this.PATH = "https://storage.googleapis.com/cilex-manga.appspot.com/";
    this.container = container;
    this.translations = translations;
    this.handler = {
      loaded: this.loaded.bind(this),
      end: this.end.bind(this),
      click: this.click.bind(this),
    };
    this.container.addEventListener("click", this.handler.click);
  }
  update(json) {
    // console.log(json);
    // 1.remove all bubbles from display
    // 2. loadNewImages
    // 3. when ready show images
    // if (Array.from(this.container.children).length > 0) {
    this.reset();
    setTimeout(() => {
      this.titleContainer = document.createElement("div");
      this.titleContainer.classList.add("title-container");
      const span = document.createElement("span");
      const paragraph = document.createElement("p");
      this.titleContainer.classList.add("hide");
      paragraph.innerText = this.translations["similar_artworks"];
      this.container.textContent = "";
      this.titleContainer.appendChild(span);
      this.titleContainer.appendChild(paragraph);
      this.container.appendChild(this.titleContainer);
      this.total = json.length;
      this.counter = 0;
      json.forEach((element) => {
        const bubble = new Bubble(`${this.PATH}${element[0]}`, element[1]);
        bubble.addEventListener("loaded", this.handler.loaded);
      });
    }, 500 + Array.from(this.container.children).length * 50);
  }
  loaded(e) {
    this.counter++;
    this.container.appendChild(e.bubble);
    if (this.counter >= this.total) {
      if (!this.isCancelled) this.show();
    }
  }
  show() {
    // only show if we are on the final screen on smaller screens
    const numBubbles = this.calculateBubbleFit();
    this.container.style.pointerEvents = "auto";
    const animDuration = 1000;
    Array.from(this.container.children).forEach((item, i) => {
      if (i > numBubbles) return;
      setTimeout(() => {
        item.classList.add("bounceInLeft");
        item.classList.remove("hide");
      }, (this.total - i) * 50);

      // remove the class so that we can apply transform on hover!
      setTimeout(() => {
        item.classList.remove("bounceInLeft");
      }, (this.total - i) * 50 + animDuration);
    });
    const delay = this.container.children.length * 50;
    window.setTimeout(() => {
      const containerHeight = this.container.clientHeight;
      this.raiseEvent("appear", [containerHeight]);
    }, delay);
  }
  reset() {
    console.log("BUBBLES reset!");
    // this.container.textContent = "";
    this.container.style.pointerEvents = "none";
    // console.log("reset, container = ", this.container, this.container.children);
    Array.from(this.container.children).forEach((item, i) => {
      setTimeout(() => {
        item.classList.remove("bounceInLeft");
        item.classList.add("bounceOutRight");
      }, (this.total - i) * 50);
    });
  }
  end(e) {
    console.log(e);
  }
  cancel() {
    // we use this to interrupt bubble showing on mobile
    this.isCancelled = true;
  }
  unCancel() {
    this.isCancelled = false;
  }
  click(e) {
    if (e.target.tagName.toLowerCase() == "img") {
      this.raiseEvent("click", [
        e.target.parentNode.getAttribute("data-assetid"),
      ]);
    }
  }

  calculateBubbleFit() {
    let containerWidth = 0.9;
    const isLandscape = Utils.isLandscapeMobile();
    if (isLandscape) containerWidth = 0.3 * 0.9;
    const screenWidth = Math.floor(window.innerWidth * containerWidth);
    let bubbleWidth = 85; // padding included

    // 2 rows on mobile and medium
    if (Utils.isMediumLayout()) {
      bubbleWidth = 76;
      const numBubblesPerRow = Math.floor(screenWidth / bubbleWidth);
      return numBubblesPerRow * 2;
    } else if (Utils.isMobileLayout() || isLandscape) {
      bubbleWidth = 65;
      const numBubblesPerRow = Math.floor(screenWidth / bubbleWidth);
      return numBubblesPerRow * 2;
    }

    // 1 row on desktop
    const pWidth = 160;
    const availableWidth = screenWidth - pWidth;
    const numBubbles = Math.floor(availableWidth / bubbleWidth);
    return numBubbles;
  }
}
